<template>
  <div class="content if-profile">
    <MPHeader  v-if="headerData" :headerData="this.headerData"/>
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <div class="finanical-report-messages">
          <h1 class="section_header">Sales Classes</h1>
          <!-- <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>What is the employment structure in your industry market? <br> <br>
                The Market Volume by Employment Class table displays the total market sales of industry sites in each
                bracket.
                Projected sales of operations for which sales cannot be ascertained (Unknown ) are noted in the column
                and are
                based on average industry site sales in the market area.
              </p> -->
          <!-- <p>The Establishments by Employment Class table displays the all market area industry operations.
                Projected employment of operations for which employment cannot be ascertained (Unknown) are based
                on average industry site employment in the market area.
              </p> -->
          <!-- </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow</md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div> -->
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Sales" md-icon="area_chart" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Sales</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Sales
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Market Volume by Class ($million)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataMarketVolume"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Market Volume by Class ($million)"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                      <md-table
                                        v-model="
                                          tableDataPercentMarketVolumeClass
                                        "
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Percent Market Volume by Class"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                      <md-table
                                        v-model="tableDataAverageSalesClass"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label"  md-label="Average Sales by Class (000)"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                               <!--  <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Percent Market Volume by Class
                                    </div>
                                  </h4>

                                </md-card-header>-->
                               <!--  <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="
                                          tableDataPercentMarketVolumeClass
                                        "
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Percent Market Volume by Class"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>-->
                              </md-card>
                              <md-card class="md-card-profile">
                               <!-- <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Average Sales by Class (000)
                                    </div>
                                  </h4>
                                 <h4 class="title text-left">Average Sales by Class (000)</h4>
                                </md-card-header>-->
                               <!-- <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataAverageSalesClass"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label"  md-label="Average Sales by Class (000)"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>-->
                              </md-card>

                            </div>

                               <md-card class="md-card-profile px-4">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Sales
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                          What is the employment structure in your industry market?<br><br>
                                          The Market Volume by Employment Class table displays the total market sales of industry sites in each bracket.
                                          Projected sales of operations for which sales cannot be ascertained (Unknown ) are noted in the column and are based
                                          on average industry site sales in the market area.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
                <md-tab
                  md-label="Employment"
                  md-icon="assignment_ind"
                  class="p-0"
                >
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Employment</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">

                              <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Employment
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Market Volume by Class ($million)</h4> -->
                                </md-card-header>
                               <!--  <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Establishments
                                    </div>
                                  </h4>
                                  <h4 class="title text-left">Establishments</h4>
                                </md-card-header>-->

                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataEstablishments"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label"  md-label="Establishments"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                      <md-table
                                        v-model="tableDataTotalEmployment"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Total Employment"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                       <md-table
                                        v-model="tableDataAverageEmployment"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Average Employment"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ numberWithCommas(item.dates[key]) }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>

                              <md-card class="md-card-profile">
                                <!--  <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Total Employment
                                    </div>
                                  </h4>
                                 <h4 class="title text-left">Total Employment</h4>
                                </md-card-header> -->
                              <!--  <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataTotalEmployment"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Total Employment"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                       <md-table
                                        v-model="tableDataAverageEmployment"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Average Employment"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content> -->
                              </md-card>
                              <md-card class="md-card-profile">
                               <!-- <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Average Employment
                                    </div>
                                  </h4>
                                   <h4 class="title text-left">Average Employment</h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                    <md-table
                                        v-model="tableDataAverageEmployment"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row
                                          slot="md-table-row"
                                          slot-scope="{ item }"
                                        >
                                          <md-table-cell
                                            class="md-table-side-label" md-label="Average Employment"
                                            >{{ item.name }}</md-table-cell
                                          >
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="salesEmpCols[key]"
                                            >{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>-->
                              </md-card>
                            </div>
                            <md-card class="md-card-profile px-4">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Employment
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                         The Establishments by Employment Class table displays the all market
                                         area industry operations. Projected employment of operations for which
                                         employment cannot be ascertained (Unknown) are based on average industry
                                         site employment in the market area.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import MPHeader from './MPHeader';

export default {
  components: {
    NavTabsCard,
    MPHeader,
  },
  mixins: [formatData],
  props:['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataMarketVolume: [],
      tableDataPercentMarketVolumeClass: [],
      tableDataAverageSalesClass: [],
      tableDataEstablishments: [],
      tableDataTotalEmployment: [],
      tableDataAverageEmployment: [],
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
    };
  },
  computed: {
    ...mapState({
      salesEmpSales: (state) =>
        state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.industryProfile.data['salesEmpEmployment'],
      release_years: (state) =>
        state?.user?.industryProfile?.general?.release_years,
      years: (state) => state.user.industryProfile.years,
      tableCompetitors: (state) =>
        state.user.industryProfile.data['competitors'],
      bznaics_code: (state) => state?.user?.industryProfile?.general?.bznaics,
      sector_name: (state) => state?.user?.industryProfile?.general?.sector,
      industry_title: (state) => state?.user?.industryProfile?.general?.industry,
      release_display: (state) =>
        state?.user?.industryProfile?.general?.['release_display'],
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
        state?.user?.industryProfile?.general?.area_display_name,
      marketVolume: (state) => state.user.industryProfile.data['marketVolume'],
      marketShare: (state) => state.user.industryProfile.data['marketShare'],
      annualSales: (state) => state.user.industryProfile.data['annualSales'],
      annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
      penetration: (state) => state.user.industryProfile.data['penetration'],
      employment: (state) => state.user.industryProfile.data['employment'],
      productivity: (state) =>
        state.user.industryProfile.data['productivityValues'],
      startupPerformance: (state) =>
        state.user.industryProfile.data['startupsValues'],
      startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
      cessation: (state) => state.user.industryProfile.data['cessation'],
      ownership: (state) => state.user.industryProfile.data['ownership'],
      demographics: (state) => state.user.industryProfile.data['demographics'],
      cmnText: (state) =>state.user.cmnText,
      cessation_years: (state) => state?.user?.industryProfile?.general?.cessation_years,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `${this.cessation_years[0]}-${this.cessation_years[1]} Cessation Rates`
        : 'Cessation Rates';
    },
    getCsvData() {
      let csvData = [
        ['Bizminer Local Industry Market Report'],
        [this.bznaics_code, this.industry_title],
        ['Sector: ' + this.sector_name],
        [this.display_area],
        [
          'Data Time Series',
          this.release_years.toString() + '-' + this.update_month,
        ],
        ['Update Month', this.update_month],
        [''],
      ];
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Annual Industry Market Volume($)'],
        ['as of:', this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g, '');
          }
        });
        csvData.push(e);
      });
      csvData.push([''], ['Share(%)'], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], [''], ['Average Annual Sales']);
      csvData.push(['', this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Rank'], ['as of:', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Market Penetration ($)']);
      csvData.push(['', this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        [
          'To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ]
      );
      csvData.push([''], ['']);
      csvData.push(['Employment', this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Market Volume by Employment Class', this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Percent Market Volume by Employment Class', this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Sales by Employment Class', this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Establishments by Employment Class', this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Total Employment by Class', this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Employment by Class', this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Productivity']);
      csvData.push(['Annual Sales per Employee', this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Average Annual Wage', this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Rent per Employee', this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Productivity Indices (%)', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Startup Activity and Performance']);
      csvData.push(['', this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], [''], ['']);
      csvData.push(
        [
          'To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ],
        [''],
        [''],
        [''],
        [''],
        [this.cessationLabel]
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Ownership/Consolidation Trends', this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Market Area Demographic Highlights']);
      csvData.push([
        '(based on zip codes co-joined with your market radius) (2015)',
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push(['']);
      });
      return csvData;
    },
  },
  mounted() {
    this.tableDataAverageSalesClass = Object.entries(
      this.salesEmpSales.avgSales
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.tableDataMarketVolume = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.tableDataPercentMarketVolumeClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));

    this.tableDataAverageEmployment = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.tableDataEstablishments = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.tableDataTotalEmployment = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    let me = this;
    let populationData = Object.entries(this.tableCompetitors).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_population.push(r);
    });

    let marketVolume = Object.entries(this.marketVolume).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    marketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      modifiedArr.push(r);
    });
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el;
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    });
    this.filtered_market_share = this.filtered_market_share.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    tableAnnual.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    });
    this.filtered_annual_sales = this.filtered_annual_sales.filter(
      (item, index) => {
        if (!item.includes('Your Firm')) {
          return item;
        }
      }
    );
    let penetrationData = Object.entries(this.penetration).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    penetrationData.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let marketVolumeByClass = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    });
    let marketPercentVolumeByClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    });
    let averageSaleByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    });
    let establishmentByClass = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    });
    let totalEmploymentByClass = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    });
    let averageEmploymentByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    });
    let annualSalesPerEmployee = Object.entries(
      this.productivity.spe
    ).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let averageAnnualWage = Object.entries(
      this.productivity.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let rentPerEmployee = Object.entries(
      this.productivity.rent
    ).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let startupPerformance = Object.entries(this.startupPerformance).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });

    let demographicInfo = Object.entries(this.demographics).map(
      ([table, data]) => ({
        name: table,
        data: Object.values(data),
      })
    );
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = [];
      this.filtered_demographic_info[index].push([element.name]);
      element.data.forEach((el, i) => {
        Object.keys(el).forEach((key) => {
          let a = el[key];
          a = a.map((e) => {
            if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e);
            } else {
              return e;
            }
          });
          if (!a.includes(key)) {
            a.unshift(key);
          }
          this.filtered_demographic_info[index].push(a);
        });
      });
    });

  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }

    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
